module.exports = __webpack_public_path__ + "img/logo_oncogite_aja.a71fe046.png";